<template>
  <div>
    <a-table
      :loading="loading"
      :pagination="false"
      :columns="columns"
      :data-source="upfileList"
      :row-key="(record) => record.mongoFileId"
    >
      <div slot="number" slot-scope="text, record, index">
        <a-input
          :disabled="disabled"
          allowClear
          class="w100"
          placeholder="请输入"
          v-model="record.number"
          @blur="duplicateChecking(record.number, index, record)"
        />
      </div>
      <div slot="method" slot-scope="text, record">
        <a-select
          allowClear
          :disabled="disabled"
          placeholder="不限"
          class="w100 ml5"
          v-model="record.method"
          @change="handleChange"
        >
          <a-select-option :value="0">否</a-select-option>
          <a-select-option :value="1">是</a-select-option>
        </a-select>
      </div>
      <div slot="problemDesc" slot-scope="text, record">
        <a-input
          :disabled="disabled"
          allowClear
          class="w100"
          placeholder="请输入"
          v-model="record.problemDesc"
          @blur="handleChange"
        />
      </div>
      <div slot="fee" slot-scope="text, record">
        <a-input
          :disabled="disabled"
          allowClear
          class="w100"
          placeholder="请输入"
          v-model="record.fee"
          @blur="handleChange"
        />
      </div>
      <div slot="remark" slot-scope="text, record">
        <a-input
          :disabled="disabled"
          allowClear
          class="w100"
          placeholder="请输入"
          v-model="record.remark"
          @blur="handleChange"
        />
      </div>
      <div slot="operator">
        {{ $store.state.app.userInfo.fullName }}
      </div>
      <div slot="action" slot-scope="text, record, index">
        <a-button type="link" class="btn-link" @click="goDetial(record, index)">
          查看
        </a-button>
        <a-divider type="vertical" />
        <a-button
          type="link"
          class="btn-link"
          @click="
            download(record.mongoFileId, record.filename, record.fileformat)
          "
        >
          下载
        </a-button>
        <a-divider type="vertical" v-if="!disabled" />
        <a-button
          v-if="!disabled"
          type="link"
          class="btn-link"
          @click="removeFiles(record.mongoFileId, record)"
        >
          删除
        </a-button>
      </div>
    </a-table>
    <div class="accessory-btn" v-if="!disabled">
      <!-- :before-upload="beforeUpload" -->
      <a-upload
        name="file"
        :multiple="false"
        :headers="headers"
        action="#"
        :fileList="fileList"
        @change="uploadFiles"
        :showUploadList="false"
        :beforeUpload="beforeUpload"
      >
        <a-button @click="fileList = []"
          ><a-icon type="upload" />上传文件
        </a-button>
      </a-upload>
    </div>

    <pigImg v-if="isImg" :url="invoiceUrl">
      <div class="img_btm">
        <div>
          <a-descriptions>
            <a-descriptions-item label="发票证号">
              <a-input
                :disabled="disabled"
                allowClear
                class="w100"
                placeholder="请输入"
                v-model="editForm.number"
                @blur="duplicateChecking(editForm.number, index)"
              />
            </a-descriptions-item>
            <a-descriptions-item label="是否符合要求">
              <a-select
                allowClear
                :disabled="disabled"
                placeholder="不限"
                class="w100 ml5"
                v-model="editForm.method"
                @change="handleChange"
              >
                <a-select-option :value="0">否</a-select-option>
                <a-select-option :value="1">是</a-select-option>
              </a-select>
            </a-descriptions-item>
            <a-descriptions-item label="发票问题描述">
              <a-input
                allowClear
                :disabled="disabled"
                class="w100"
                placeholder="请输入"
                v-model="editForm.problemDesc"
                @blur="handleChange"
              />
            </a-descriptions-item>
            <a-descriptions-item label="票证金额">
              <a-input
                :disabled="disabled"
                allowClear
                class="w100"
                placeholder="请输入"
                v-model="editForm.fee"
                @blur="handleChange"
              />
            </a-descriptions-item>
            <!-- <a-descriptions-item label="发票备注">
              <a-input
                :disabled="disabled"
                allowClear
                class="w100"
                placeholder="请输入"
                v-model="editForm.remark"
                @blur="handleChange"
              />
            </a-descriptions-item> -->
          </a-descriptions>
        </div>

        <div class="imgBtn">
          <a-button type="primary" class="mr20" @click="confirmEdit">
            确定
          </a-button>
          <a-button @click="isImg = false" class="mr20"> 返回 </a-button>
        </div>
      </div>
    </pigImg>
  </div>
</template>
<script>
const columns = [
  {
    title: '文件名称',
    dataIndex: 'filename',
    key: 'filename',
    width: 90
  },
  {
    title: '文件格式',
    dataIndex: 'fileformat',
    key: 'fileformat'
    // width: 90
  },
  {
    title: '上传时间',
    dataIndex: 'createTime',
    key: 'createTime'
    // width: 140
  },
  {
    key: 'method',
    scopedSlots: { customRender: 'method' },
    title: '是否符合要求',
    align: 'left'
    // width: 80
  },
  // {
  //   title: '操作人',
  //   dataIndex: 'operator',
  //   key: 'operator',
  //   scopedSlots: { customRender: 'operator' }
  // },
  {
    key: 'number',
    scopedSlots: { customRender: 'number' },
    title: '发票号码',
    align: 'left'
    // width: 80
  },

  {
    key: 'fee',
    scopedSlots: { customRender: 'fee' },
    title: '票证金额',
    align: 'left'
    // width: 80
  },
  {
    key: 'problemDesc',
    scopedSlots: { customRender: 'problemDesc' },
    title: '发票问题描述',
    align: 'left'
    // width: 80
  },

  {
    key: 'operation',
    scopedSlots: { customRender: 'action' },
    title: '操作',
    align: 'left',
    width: 180
  }
]
import { kkFileUrl, fileUrlHOST } from '@/http/config'
import { saveFile, getFile, invoiceDistinct } from '@/http/url'
import { getSuffix, formatDate } from '@/assets/js/auth'
import pigImg from '@/components/pigImg.vue'
export default {
  components: {
    pigImg
  },
  props: ['disabled', 'updateList', 'file', 'detailsId'],
  model: {
    event: 'input',
    prop: 'updateList'
  },
  data() {
    return {
      columns,
      data: [],
      headers: {
        Authentication: localStorage.getItem('token')
      },
      loading: false,
      isImg: false,
      fileList: [],
      upfileList: [], //上传成功的附件列表
      record: {},
      targetIndex: null, // 当前操作行index
      editForm: {},
      invoiceUrl: ''
    }
  },
  watch: {
    file(val) {
      if (val) {
        this.upfileList = this.file
      }
    },
    upfileList: {
      handler(val) {
        this.emitData()
      },
      deep: true
    }
  },
  mounted() {
    if (this.file) {
      this.upfileList = this.file
    }
  },
  methods: {
    // 发票号码查重
    duplicateChecking(value, index, record) {
      if (!this.isEmpty(value)) {
        invoiceDistinct({ number: value }).then((res) => {
          if (res.data.code == 0 && !res.data.data) {
            this.$message.error('当前发票号已存在')
            if (index) {
              this.updateList[index]['number'] = ''
            } else {
              this.editForm.number = ''
            }
          } else {
            // 直接调用api修改发票号码
            this.handleChange()
          }
        })
      }
    },
    //弹层中的确定编辑按钮
    confirmEdit() {
      let rowData = this.upfileList[this.targetIndex]
      rowData.number = this.editForm.number
      rowData.method = this.editForm.method
      rowData.problemDesc = this.editForm.problemDesc
      rowData.fee = this.editForm.fee
      rowData.remark = this.editForm.remark
      this.upfileList.splice(this.targetIndex, 1, rowData)
      this.isImg = false
    },
    formatDateIt(data) {
      // 时间格式化
      return formatDate(data)
    },
    goDetial(item, index) {
      // 查看
      this.isImg = true
      this.invoiceUrl = item.fileUrl
      this.targetIndex = index
      this.editForm = Object.assign({}, this.upfileList[index])
    },
    // 上传附件
    uploadFiles(file) {
      if (file.file.size > 10485760) {
        // 大于10M 拦截
        this.$message.error('上传文件不得大于10M！')
      } else {
        this.saveFileFn(file.file)
      }
    },
    // 移除
    removeFiles(id, record) {
      this.$confirm({
        title: '确定删除吗?',
        okType: 'danger',
        onOk: () => {
          // 新增删除
          let index = this.upfileList.findIndex(
            (item) => item.mongoFileId == id
          )
          this.updateList.splice(index, 1)
          this.$message.success('删除成功')
          if (this.detailsId) {
            this.handleChange()
          }
        }
      })
    },
    download(mongoFileId, filename, fileformat) {
      // 下载附件
      this.$message.success('下载中')
      getFile(mongoFileId).then((res) => {
        let blob = new Blob([res.data], {
          type: 'application/vnd.ms-excel'
        })
        let fileName = filename + '.' + fileformat
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, fileName)
        } else {
          var link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = fileName
          link.click()
          //释放内存
          window.URL.revokeObjectURL(link.href)
        }
      })
    },
    beforeUpload() {
      return false
    },
    saveFileFn(file) {
      const formDataChildren = new FormData()
      formDataChildren.append('file', file)
      this.$message.loading('上传中···', 0)
      saveFile(formDataChildren).then((res) => {
        if (res.data.code == 0) {
          this.$message.destroy()
          this.$message.success('上传成功')
          let fileData = {}
          let SuffixArray = getSuffix(file.name)
          fileData.filename = SuffixArray[1]
          fileData.fileformat = SuffixArray[0]
          fileData.mongoFileId = res.data.data
          fileData.kkFileUrl = kkFileUrl
          fileData.fileUrl =
            fileUrlHOST +
            'mongo/kkFile?fileId=' +
            fileData.mongoFileId +
            '&fullfilename=' +
            SuffixArray[2]

          fileData.createTime = this.formatDateIt(new Date())
          this.upfileList.push(fileData)

          this.emitData()
        } else {
          this.$message.error('上传失败')
        }
      })
    },
    emitData() {
      this.$emit('input', this.upfileList)
    },
    handleChange() {
      this.$emit('change', this.upfileList)
    }
  }
}
</script>
<style scoped lang="scss">
.accessory-btn {
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.img_btm {
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  .imgBtn {
    display: flex;
    align-items: center;
    justify-content: space-around;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/HeatingFee/components/warm-invoice.vue